module.exports = __webpack_public_path__ + "img/2016-08.175fc577.jpg";